// Spielstärke von Stockfish: 1350 bis 3150 Elo in 50er-Schritten (geeicht über UCI_Elo), darüber volle Stärke,
// darunter vier Einsteiger-Stufen (1150–1300) ohne gemessene Elo, siehe server PlayStrength.java.
import { t } from './i18n';

export const ELO_BEGIN = 1150;
export const ELO_MIN = 1350;
export const ELO_FULL = 3200; // oberste Stufe: ohne Begrenzung

export const eloLabel = (elo: number) =>
  elo >= ELO_FULL ? t('volle Stärke') : elo < ELO_MIN ? t('Einsteiger {n}', { n: Math.max(1, Math.min(4, (elo - 1100) / 50)) }) : `${elo} Elo`;
